
  import { Component, Prop, Vue } from 'vue-property-decorator'

  export default  {
    name: 'TitleCard',
    props: {
      titleMsg1: {
        type: String
      },
      titleMsg2: {
        type: String
      },
      titleMsg3: {
        type: String
      },
      titleMsg4: {
        type: String
      }
    }
  }
